module.exports = __webpack_public_path__ + "static/media/cityofdata.44da3b10.jpg";